/* eslint-disable eqeqeq */
const transformDate = (dt) => {
  const date = dt?.split('/');

  return date
    ?.map((i) => {
      if (i <= 9 && i.length == 1) {
        return `0${i}`;
      }
      return i;
    })
    .join('/');
};
export default transformDate;
